(function () {
  const DEFAULT_MAX = 12;
  const DEFAULT_ERROR = "Change the quantity";

  function getConfig() {
    if (window.__pdpGelBundleLimitConfig) return window.__pdpGelBundleLimitConfig;

    const configEl = document.getElementById("pdp-gel-bundle-limit-config");
    if (configEl) {
      try {
        window.__pdpGelBundleLimitConfig = JSON.parse(configEl.textContent);
        return window.__pdpGelBundleLimitConfig;
      } catch (_error) {
        /* fall through to defaults */
      }
    }

    window.__pdpGelBundleLimitConfig = {
      maxTotalQuantity: DEFAULT_MAX,
      errorMessage: DEFAULT_ERROR,
      flavorVariantIds: [],
    };
    return window.__pdpGelBundleLimitConfig;
  }

  function getMax() {
    return Number(getConfig().maxTotalQuantity || DEFAULT_MAX);
  }

  function getErrorMessage() {
    return getConfig().errorMessage || DEFAULT_ERROR;
  }

  function getFlavorVariantIds() {
    const ids = getConfig().flavorVariantIds;
    return Array.isArray(ids) ? ids.map(Number) : [];
  }

  function isBundleFlavorItem(item, flavorVariantIds = null) {
    if (!item) return false;

    const props = item.properties || {};
    if (props["_main_bundle-id"]) return true;

    const ids = flavorVariantIds || getFlavorVariantIds();
    if (ids.length && ids.includes(Number(item.variant_id))) return true;

    return false;
  }

  function getTotalQuantity(items, lineIndexToReplace = null, replacementQty = null, flavorVariantIds = null) {
    if (!Array.isArray(items)) return 0;

    return items.reduce((sum, item, idx) => {
      if (!isBundleFlavorItem(item, flavorVariantIds)) return sum;
      const qty = lineIndexToReplace === idx ? replacementQty : item.quantity;
      return sum + (Number(qty) || 0);
    }, 0);
  }

  function wouldExceedLimit(items, lineIndex, newQty, flavorVariantIds = null) {
    return getTotalQuantity(items, lineIndex, newQty, flavorVariantIds) > getMax();
  }

  function updateQuantityInputLimits(cart) {
    if (!cart?.items) return;

    const max = getMax();
    const total = getTotalQuantity(cart.items);

    cart.items.forEach((item, idx) => {
      if (!isBundleFlavorItem(item)) return;

      const line = idx + 1;
      const input =
        document.getElementById(`Drawer-quantity-${line}`) ||
        document.getElementById(`Quantity-${line}`);
      if (!input) return;

      const otherTotal = total - item.quantity;
      const maxForLine = Math.max(0, max - otherTotal);
      input.setAttribute("max", String(maxForLine));

      const quantityInput = input.closest("quantity-input");
      if (quantityInput?.validateQtyRules) quantityInput.validateQtyRules();
    });
  }

  window.PdpGelBundleLimit = {
    getConfig,
    getMax,
    getErrorMessage,
    getFlavorVariantIds,
    isBundleFlavorItem,
    getTotalQuantity,
    wouldExceedLimit,
    updateQuantityInputLimits,
  };
})();
